import { type AlbumCollectionItemModel } from '@/shared/api'
import { COMMON_COLUMN_WIDTH } from '@/shared/lib/styling'
import { TableDragHandle } from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { DragSortTable, type ProColumns } from '@ant-design/pro-components'
import { Modal } from 'antd'
import { useUnit } from 'effector-react'

import {
  $albumsOrdered,
  $isAlbumOrderModalOpen,
  albumOrderModalClosed,
  albumsReordered,
} from '../model/album-collection-form-albums.model'

interface AlbumReorderModalProps {
  onApply: (orderedAlbums: AlbumCollectionItemModel[]) => void
}

export const AlbumReorderModal = ({ onApply }: AlbumReorderModalProps) => {
  const albums = useUnit($albumsOrdered)
  const reorderAlbums = useUnit(albumsReordered)

  const isOpen = useUnit($isAlbumOrderModalOpen)
  const close = useUnit(albumOrderModalClosed)

  const columns: ProColumns<AlbumCollectionItemModel>[] = [
    {
      dataIndex: 'sort',
      width: COMMON_COLUMN_WIDTH.DRAG,
      render: () => null,
      onCell: () => ({
        style: {
          backgroundColor: '#fafafa',
        },
      }),
    },
    {
      title: 'Название',
      dataIndex: 'name',
      key: 'name',
      render: (_, album) => {
        return album.name
      },
    },
  ]

  const handleDragSortEnd = (
    _beforeIndex: number,
    _afterIndex: number,
    albumsReordered: AlbumCollectionItemModel[],
  ) => {
    const originalIndexMap = new Map<string, number>()
    albums.forEach((track, idx) => {
      originalIndexMap.set(track.id, idx)
    })

    reorderAlbums(albumsReordered)
  }

  return (
    <Modal
      centered
      title="Изменение порядка сезонов"
      open={isOpen}
      onCancel={close}
      style={{ maxWidth: '620px' }}
      footer={
        <PrimaryButton
          onClick={() => {
            onApply(albums)
            close()
          }}
        >
          Сохранить
        </PrimaryButton>
      }
    >
      <DragSortTable
        options={false}
        columns={columns}
        showHeader={false}
        rowKey="id"
        search={false}
        pagination={false}
        dataSource={albums || []}
        dragSortKey="sort"
        dragSortHandlerRender={TableDragHandle}
        onDragSortEnd={handleDragSortEnd}
        locale={{ emptyText: 'Сезоны не выбраны' }}
      />
    </Modal>
  )
}
